/**
 * App tiles: boxes the YDM app draws from Supabase, declared in Looker as a
 * text element whose body carries [ydm-app:<widget>] (plan 2026-10-12-looker-d1-phase3,
 * ruling 1). The marker is the only contract between the builder, Looker and
 * the server — keep its format here and nowhere else.
 */
export const APP_WIDGETS = ['attention', 'dataQuality', 'outcomes', 'budgetPacing'] as const;
export type AppWidget = (typeof APP_WIDGETS)[number];

/**
 * Widgets the app no longer draws. A stored spec or a Looker element may still
 * name one: the spec drops that tile on parse and the server skips the element
 * (backfill became a filter-bar pill, and freshness merged into the "data as of"
 * pill, both 2026-10-13).
 */
export const RETIRED_WIDGETS = ['backfill', 'freshness'] as const;

const MARKER = /\[ydm-app:([A-Za-z]+)\]/;

/** What the builder writes into the Looker text element's body. */
export const appMarker = (widget: AppWidget): string => `Drawn by the YDM app. [ydm-app:${widget}]`;

/** The widget a text element's body names, or null (an ordinary note). */
export const widgetOfMarker = (body: string | null | undefined): AppWidget | null => {
  const m = body ? MARKER.exec(body) : null;
  return m && (APP_WIDGETS as readonly string[]).includes(m[1]) ? (m[1] as AppWidget) : null;
};
